// @vue/component
export default {
  name: 'ReportsFormExportItemProject',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fieldValue: '',
      rules: [
        { required: true, validator: this.__validateProjectValues },
      ],
    };
  },

  computed: {
    getProjectsList() {
      return this.$store.getters['client/projects/list'].records;
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/projects/list',
      ]);
    },
  },

  created() {
    this.$store.dispatch('client/projects/getList');
  },

  methods: {
    __validateProjectValues(rule, value, callback) {
      if (value !== '') callback();
      else callback(new Error('Nie wybrano projektu'));
      callback();
    },
  },
};
